import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import classNames from 'classnames';
import {Grid, MenuItem, TextField} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import {setConsumer} from "../../../app/slices/consumersSlice";
import {
    showModal,
} from '../../../app/slices/modalSlice';
import _ from "lodash";
import {infoFieldsArray} from "./config";
import { apiClient } from "../../../providers/apiClient";
import {APP_URLS, STORAGE} from "../../../app/config";

function translateRoles(input) {
    const roleMap = {
        "Administrator": "administrator",
        "Redaktor": "editor",
    };

    return input
        .split(",")
        .map(role => role.trim())
        .map(role => roleMap[role] || role)
        .join(", ");
}

function UserInfoForm({isCreate, canEdit, onUpdate, model, errors, setConsumer, isAdmin}) {
    const {t} = useTranslation('AccountDetailsScreen', {keyPrefix: 'InfoForm'});
    const [apiUserRoles, setApiUserRoles] = useState([]);

    const [currentEdit, setCurrentEdit] = React.useState('');

    const checkIfDisabled = (field) => !isCreate && (!canEdit || field !== currentEdit);
    const getErrorMessage = (field) => _.find(errors, (error) => error.field === field);
    const handleFieldChange = (field, value) => setConsumer({field, value});

    const handleUpdate = async (name, value) => {
        await onUpdate(name, value);

        setCurrentEdit(null);
    }



    useEffect(() => {
        document.documentElement.style.setProperty('--blocked-sector-position-text', `'${t('blockedSectorPositionText')}'`);
    }, [t])

    useEffect(() => {
        apiClient.get(APP_URLS.GET_ROLES).then(res => {
            const roles = res?.data?.map(r => {
                return {
                    value: r.id,
                    text: translateRoles(r.name)
                }
            })

            setApiUserRoles(roles);
        })
    }, []);

    const roleInfoField = useMemo(() => {
        return {
            name: 'role',
            modelName: 'Role',
            onlyForAdmin: true,
            items: apiUserRoles
        }
    }, [apiUserRoles]);

    return (
        <div
            className={
                classNames(
                    'fk-form-section',
                    {
                        'edit-mode': canEdit
                    }
                )
            }
        >
            <h3 className="title">
                {t('title')}
            </h3>
            <Grid container spacing={2}>
                {[...infoFieldsArray, roleInfoField].filter(({hideOnCreate}) => (isCreate && !hideOnCreate) || !isCreate)
                    .map(({name, modelName, required, items, multiple, onlyForAdmin}, index) => (
                        <React.Fragment key={index}>
                            <Grid item md={3} className="fk-label">
                                <label htmlFor={name}>{`${t(name)}${(required ? '*' : '')}`}</label>
                            </Grid>
                            <Grid item md={8} className={
                                classNames(
                                    'fk-input-container',
                                    {
                                        'edit-mode': canEdit,
                                        'has-error': !!getErrorMessage(name),
                                    }
                                )
                            }>
                                <TextField
                                    fullWidth
                                    select={!!items}
                                    disabled={checkIfDisabled(name)}
                                    className="fk-input"
                                    placeholder={t(`${name}Placeholder`)}
                                    helperText={getErrorMessage(name)?.error}
                                    value={model ? model[name] ?? '' : !!items ? '' : ''}
                                    onChange={(event) => handleFieldChange(name, event.target.value)}
                                    SelectProps={{
                                        multiple: multiple,
                                    }}
                                >
                                    {items && items.map(({value, text}, index) => {
                                        if(text === "Użytkownik") {
                                            return;    
                                        }
                                        
                                        return (
                                            <MenuItem key={index} value={value}>
                                                {t(text)}
                                            </MenuItem>
                                        )
                                    })}
                                </TextField>
                            </Grid>
                            {modelName && canEdit && (onlyForAdmin ? isAdmin : true) ?
                                <Grid item md={1}>
                                    {name !== currentEdit
                                        ? <button
                                            className="fk-edit-button"
                                            onClick={() => setCurrentEdit(name)}
                                        >
                                            <EditIcon/>
                                        </button>
                                        : <button
                                            className="fk-edit-button"
                                            onClick={() => handleUpdate(modelName, model[name])}
                                        >
                                            <SaveIcon/>
                                        </button>
                                    }
                                </Grid>
                                : <Grid item md={1}/>
                            }
                        </React.Fragment>
                    ))}
            </Grid>
        </div>
    );
}

const mapStateToProps = (state) => ({
    model: state.consumers.consumer,
    errors: state.consumers.errors,
});

const actions = {
    setConsumer,
    showModal,
};

export default connect(mapStateToProps, actions)(UserInfoForm);